import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';

import ExchangeUI from '../ExchangeUI';
import TransactionComplete from './TransactionComplete';

export default function BazaarDialogComponent(props) {
  const {
    isTransacting,
    onRequestClose,
    onTransactionComplete,
    quantities,
    successMessage,
  } = props;

  if (isTransacting) {
    return <Loading spinner />;
  }

  if (successMessage) {
    return <TransactionComplete onRequestClose={onRequestClose} successMessage={successMessage} />;
  }

  return (
    <ExchangeUI
      quantities={quantities}
      onRequestClose={onRequestClose}
      onTransactionComplete={onTransactionComplete}
    />
  );
}

BazaarDialogComponent.displayName = 'BazaarDialogComponent';

BazaarDialogComponent.propTypes = {
  isTransacting: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  quantities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onTransactionComplete: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
};

BazaarDialogComponent.defaultProps = {
  successMessage: undefined,
};
